import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Normalized } from 'shared/hooks/useSupportedChains/types';
import { normalizeData } from 'shared/hooks/useSupportedChains/utils';

import { IApiPackage } from '../api/types';

import { packagesData } from './constants';
import { IPackage } from './model.types';

type ContractId = string | number;

export type PackagesState = {
  packages: Record<ContractId, IPackage>;
  ownedPackage: IPackage | null;
  ownedNftId: number | null;
  selectedIndex: number;
};

export const initialState: PackagesState = {
  packages: normalizeData(packagesData, 'contractId'),
  ownedPackage: null,
  selectedIndex: 0,
  ownedNftId: null,
};

const packagesSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    setPackages(state, { payload: apiPackages }: PayloadAction<Normalized<IApiPackage>>) {
      state.packages = Object.fromEntries(
        Object.entries(apiPackages).map(([contractId, newPackage]) => {
          const existing = state.packages[contractId];
          return [
            contractId,
            {
              ...existing,
              name: newPackage.name,
              units: {
                available: newPackage.available,
                total: newPackage.total,
              },
              price: newPackage.priceUsd,
            },
          ];
        }),
      );
    },

    setPackage(state, action: PayloadAction<number>) {
      if (action.payload >= 0 && action.payload < Object.keys(state.packages).length) {
        state.selectedIndex = action.payload;
      }
    },

    setOwnedPackage(state, action: PayloadAction<IPackage>) {
      state.ownedPackage = action.payload;
    },

    clearOwnedPackage(state) {
      state.ownedPackage = null;
    },

    setOwnedNftId(state, action: PayloadAction<number | null>) {
      state.ownedNftId = action.payload;
    },
  },
});

export const { reducer, actions } = packagesSlice;
